export { StoryblokImageV2 } from './StoryblokImageV2'
